module.exports = __webpack_public_path__ + "assets/media/map.15419a18.svg";